
    import _Handlebars from 'handlebars/runtime';
    var Handlebars = _Handlebars.default;
    import "coffeescripts/handlebars_helpers.coffee";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = 'calendar/calendarApp';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  


  return "<div class=\"scheduler-wrapper\" style=\"display: none\">\n  <div class=\"appointment-list\">\n    <div class=\"list-wrapper\"></div>\n  </div>\n</div>\n<div class=\"agenda-wrapper\"></div>\n<div class=\"scheduler_navigator\"></div>\n<div class=\"calendar\"></div>\n";
  });
    ;
    
    import brandableCss from 'compiled/util/brandableCss';
    brandableCss.loadStylesheet('jst/calendar/calendarApp', {"new_styles_normal_contrast":{"combinedChecksum":"9fd9da880a"},"new_styles_high_contrast":{"combinedChecksum":"2481ec2c9f"},"responsive_layout_normal_contrast":{"combinedChecksum":"9fd9da880a"},"responsive_layout_high_contrast":{"combinedChecksum":"2481ec2c9f"},"new_styles_normal_contrast_rtl":{"combinedChecksum":"38056f8961"},"new_styles_high_contrast_rtl":{"combinedChecksum":"a342ec814a"},"responsive_layout_normal_contrast_rtl":{"combinedChecksum":"38056f8961"},"responsive_layout_high_contrast_rtl":{"combinedChecksum":"a342ec814a"}}[brandableCss.getCssVariant()]);
  ;
    export default templates[name];
  